export const getExportPricesWithMostCountriesCount = product => {
  const countriesCount = product?.inventory_items?.map(item => item?.export_details?.length || 0)
  const maxCountriesCount = Math.max(...countriesCount)

  return maxCountriesCount
}
